<template>
    <section
        class="flex flex-col bg-white border-t border-gray-DFDFDF lg:border-none max-h-screen"
        :class="{ 'opacity-0': isPrintMode }"
    >
        <product-header class="cz-hidden lg:block" />

        <div :class="[
            'flex items-center justify-between px-[24px] md:px-10 mt-[16px] lg:mt-0 lg:mb-0 pb-[12px]',
            'border-b border-gray-DFDFDF font-oceanside'
        ]">
            <step-progress />
            <div
                class="mr-[12px] items-center cz-hidden lg:flex"
                v-if="shouldShowResetButton"
            >
                <modal-button
                    @confirm="handleReset"
                    :modal-heading="$t('RESET_CONFIRM')"
                    :modal-copy="$t('RESET_CONFIRM_COPY')"
                >
                    <template #cta>{{ $t('RESET') }}</template>
                </modal-button>
                <div class="ml-[12px]">|</div>
            </div>
            <button
                :class="[
                    'cz-hidden lg:flex cursor-pointer items-center justify-center group',
                    'focus:outline-none focus:ring-1 focus:ring-black focus:border-black ring-offset-2',
                ]"
                @click="handleShowSummary"
            >
                <span class="underline flex-none group-hover:text-red mr-[5px]">{{ $t('SUMMARY') }}</span>
                <summary-icon class="group-hover:text-red" />
            </button>
        </div>

        <!-- level 1 panel -->
        <step-option-list />

        <!-- level 2 panel -->
        <swiper-list />

        <!-- nested panels -->
        <step-options-nested-panels
            :is-dirty="false"
        />
    </section>
</template>

<script>
    import allStores from '../stores/all';

    import ProductHeader from './ProductHeader.vue';
    import StepProgress from './StepProgress.vue';
    import StepOptionList from './StepOptionList.vue';
    import SwiperList from './SwiperList.vue';
    import StepOptionsNestedPanels from './StepOptionsNestedPanels.vue';
    import ModalButton from './buttons/ModalButton.vue';
    import SummaryIcon from './SummaryIcon.vue';

    export default {
        mixins: [allStores],

        emits: ['overlayClose'],

        components: {
            SummaryIcon,
            ModalButton,
            ProductHeader,
            StepProgress,
            StepOptionList,
            SwiperList,
            StepOptionsNestedPanels,
        },

        data() {
            return {
                slideProgress: 0,
                shouldShowReset: false,
            };
        },
        computed: {
            isMobile() {
                return this.appStore.isMobile;
            },
            shouldShowSummary() {
                return this.appStore.shouldShowSummary;
            },
            inErrorState() {
                return false;
            },
            totalSelectionsMade() {
                return this.customizerStore.totalSelectionsMade;
            },
            shouldShowResetButton() {
                return this.customizerStore.hasChanged;
            },
            isPrintMode() {
                return this.appStore.isPrintMode;
            },
            viewController() {
                return this.customizerStore.viewController;
            },
        },

        methods: {
            isGroupLocked(group) {
                return this.customizerStore.isGroupLocked(group);
            },
            setShowGroupOverlay(value) {
                this.appStore.setShowGroupOverlay(value);
            },
            setShouldShowSummary(value) {
                this.appStore.setShouldShowSummary(value);
            },
            handleShowSummary() {
                this.setShouldShowSummary(true);
                this.setShowGroupOverlay(true);
            },
            handleOnCloseOverlay() {
                setTimeout(() => {
                    this.setShouldShowSummary(false);
                }, 500);
            },
            handleReset() {
                this.customizerStore.clearPaletteSwatchSlots();
                this.customizerStore.resetAll();
                this.customizerStore.removePanelFromErrorState('Main');
                this.appStore.resetCustomization();
            },
        },
    };
</script>
